import { flatMap } from "lodash";
import { PackageType } from "../classes/package-listing";
import { IPackage } from "../custom/classes/production";

export function getAllPackagePerformances(pkg: IPackage) {
    if (pkg.packageType === PackageType.Super) {
        return flatMap(pkg.subPackages.map(subPackage =>
            flatMap(subPackage.performanceGroupDetails
                .map(group => flatMap(group.appProductions.map(prod => prod.performances))))));    
    }

    return flatMap(pkg.performanceGroupDetails
        .map(group => flatMap(group.appProductions.map(prod => prod.performances))));
}